module.exports = "<p>\r\n  awsop-lab6 works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab6/awsop-lab6.component.html
// module id = ./src/app/course/labs/awsop/awsop-lab6/awsop-lab6.component.html
// module chunks = main